import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { TutotialListPage } from './list';

export const TutorialModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<TutotialListPage />} />
      </Routes>
    </PageContentWrapper>
  );
};
